import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";

function SignatureModal({ isOpen, onClose, onSave }) {
  const sigRef = useRef(null);

  if (!isOpen) return null;

  const handleClear = () => {
    sigRef.current?.clear();
  };

  const handleSave = () => {
    if (sigRef.current?.isEmpty()) {
      alert("لطفاً ابتدا امضا کنید.");
      return;
    }
    const dataUrl = sigRef.current
      // .getTrimmedCanvas()
      .toDataURL("image/png");
    onSave(dataUrl); // امضا را به والد می‌فرستیم
    onClose();
  };

  return (
    <div style={styles.backdrop}>
      <div style={styles.modal}>
        <h3 style={{ marginBottom: 16 }}>امضای دیجیتال</h3>

        <SignatureCanvas
          ref={sigRef}
          penColor="black"
          canvasProps={{
            width: 400,
            height: 200,
            style: { border: "1px solid #ccc", borderRadius: 8 }
          }}
        />

        <div style={styles.buttonsRow}>
          <button onClick={handleClear} style={styles.secondaryButton}>
            پاک کردن
          </button>
          <div style={{ flex: 1 }} />
          <button onClick={onClose} style={styles.secondaryButton}>
            انصراف
          </button>
          <button onClick={handleSave} style={styles.primaryButton}>
            ثبت امضا
          </button>
        </div>
      </div>
    </div>
  );
}

export default function SignatureWithModal({ isOpen, onClose,setImg,handleSubmit}) {
//   const [isModalOpen, setIsModalOpen] = useState(false);
  const [signature, setSignature] = useState(null);

  const handleSaveSignature = (dataUrl) => {
    console.log(888)
    console.log(dataUrl)
    setSignature(dataUrl);
    // setImg(dataUrl)
    handleSubmit(dataUrl)
    // اینجا می‌تونی امضا رو به سرور هم بفرستی
    // fetch("/api/upload-signature", { ... })
  };

  return (
    <div style={{ padding: 24 }}>
      <h2>فرم با امضای دیجیتال</h2>

      <button
        onClick={() => onClose(true)}
        style={styles.primaryButton}
      >
        افزودن / ویرایش امضا
      </button>

      {signature && (
        <div style={{ marginTop: 20 }}>
          <h4>امضای ذخیره‌شده:</h4>
          <img
            src={signature}
            alt="signature"
            style={{ maxWidth: 300, border: "1px solid #ddd" }}
          />
        </div>
      )}

      <SignatureModal
        isOpen={isOpen}
        onClose={() => onClose(false)}
        onSave={handleSaveSignature}
      />
    </div>
  );
}

// --- استایل ساده مدال و دکمه‌ها ---
const styles = {
  backdrop: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999
  },
  modal: {
    backgroundColor: "#fff",
    borderRadius: 12,
    padding: 20,
    minWidth: 450,
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
    direction: "rtl"
  },
  buttonsRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginTop: 16
  },
  primaryButton: {
    padding: "8px 16px",
    borderRadius: 8,
    border: "none",
    cursor: "pointer",
    backgroundColor: "#2563eb",
    color: "#fff",
    fontSize: 14
  },
  secondaryButton: {
    padding: "8px 16px",
    borderRadius: 8,
    border: "1px solid #ccc",
    cursor: "pointer",
    backgroundColor: "#f9fafb",
    fontSize: 14
  }
};
